import { QUERY_KEYS } from '@forwardflow/helpers/utils/constants'
import CampaignService from '@forwardflow/services/CampaignService'
import useSWR from 'swr'

export const useGetAllRecommendedCampaign = () => {
   const response = useSWR([QUERY_KEYS.GET_RECOMMENDED_CAMPAIGNS], () =>
      CampaignService.getAllRecommendedCampaigns()
   )
   return {
      ...response,
   }
}
